import {createEvent} from "./createEvent";

export const waitListEvents = {
    added: createEvent(),
    updated: createEvent(),
};
